import React, {
    MutableRefObject,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import { ReadMore } from "./TextExpander.styles";
import { TextExpanderType } from "./TextExpander.types";
import { Box } from "@mui/system";
import { addPxPostfix } from "../addPxPostfix";

const LINE_HEIGHT = 20;

export const TextExpander = function ({
    isOwnMessage,
    lineClampValue,
    children,
}: TextExpanderType) {
    const [isReadMoreFlag, setIsReadMoreFlag] = useState(true);
    const [scrollHeight, setScrollHeight] = useState<number>();
    const toggleReadMore = (event: React.MouseEvent) => {
        event.stopPropagation();
        setIsReadMoreFlag(!isReadMoreFlag);
    };
    const ref: MutableRefObject<HTMLDivElement | undefined> = useRef();

    useEffect(() => {
        ref.current && setScrollHeight(ref.current.scrollHeight);
    }, [ref.current]);

    const isOverflow = useMemo(() => {
        if (!scrollHeight) {
            return false;
        }
        return scrollHeight / LINE_HEIGHT > lineClampValue;
    }, [scrollHeight]);

    return (
        <>
            <Box
                ref={ref}
                sx={{
                    overflow: isReadMoreFlag ? "hidden" : "visible",
                    lineHeight: addPxPostfix(LINE_HEIGHT),
                    color: isOwnMessage
                        ? "white"
                        : "var(--community-color-primary-text)",
                    minWidth: isOverflow ? "115px" : "auto",
                    minHeight: isOverflow
                        ? addPxPostfix(lineClampValue * LINE_HEIGHT)
                        : "auto",
                    height:
                        isOverflow && isReadMoreFlag
                            ? addPxPostfix(lineClampValue * LINE_HEIGHT)
                            : "auto",
                    ...(isReadMoreFlag
                        ? {
                              display: "-webkit-box",
                              WebkitLineClamp: lineClampValue,
                              WebkitBoxOrient: "vertical",
                          }
                        : {}),
                }}
            >
                <>{children}</>
            </Box>
            {isOverflow && (
                <ReadMore
                    onClick={toggleReadMore}
                    sx={{
                        fontWeight: "500",
                        color: isOwnMessage
                            ? "white"
                            : "var(--community-color-primary-text)",
                    }}
                >
                    {isReadMoreFlag ? "Weiterlesen" : "Weniger anzeigen"}
                </ReadMore>
            )}
            {isOverflow === undefined && <Box sx={{ height: "20px" }} />}
        </>
    );
};
